import { Container } from '@hover/blueprint';
import { graphql } from 'gatsby';
import React, { FC } from 'react';
import { BlogPost } from '../../components/blog';
import { Layout, NewsLetterBar, SearchBar } from '../../components/common';
import { IBlogPost } from '../../interfaces/IBlogPost';

interface BlogPostQuery {
  data: {
    contentfulBlogPost: IBlogPost;
  };
}

const BlogPostRoute: FC<BlogPostQuery> = ({ data }) => (
  <Layout>
    <Container maxW="1232px" pb={{ base: 600, desktop: 700 }}>
      <SearchBar handleSubmit={() => {}} />
    </Container>
    <BlogPost
      post={data.contentfulBlogPost}
      pb={{ base: '82px', tablet: 1100 }}
    />
    <NewsLetterBar showForm />
  </Layout>
);

export default BlogPostRoute;

export const pageQuery = graphql`
  query NewBlogPostBySlug($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      slug
      categories
      publishDate(formatString: "MM/DD/YYYY")
      heroImage {
        fluid(maxWidth: 1180, maxHeight: 500) {
          ...GatsbyContentfulFluid
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
      description {
        description
      }
    }
  }
`;
